import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "cart-promo__block" };
const _hoisted_2 = {
    key: 0,
    class: "cart-promo__list"
};
import CouponListItem from "./CouponListItem.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CouponList',
    props: {
        coupons: { type: Array, required: true },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.coupons.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.coupons, (coupon, key) => {
                            return (_openBlock(), _createBlock(CouponListItem, {
                                coupon: coupon,
                                key: key
                            }, null, 8 /* PROPS */, ["coupon"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
